import { useLogger } from '@capsicum/common';
import { type WalletConnectEventHandler, type WalletConnectSession } from '@socios-blk/core';
import { createContext, useContext } from 'react';

export type WalletConnectContextShape = {
	connectWallet?: (uri: string) => Promise<void>;
	disconnectWallet?: (topic: string) => Promise<void>;
	walletConnectEventHandler?: WalletConnectEventHandler;
	walletConnectSessions: Array<WalletConnectSession>;
};

export const WalletConnectContext = createContext<WalletConnectContextShape>({
	connectWallet: undefined,
	disconnectWallet: undefined,
	walletConnectEventHandler: undefined,
	walletConnectSessions: []
});

export const useWalletConnectContext = () => {
	const context = useContext(WalletConnectContext);
	const logger = useLogger();

	if (!context) {
		logger.error('WalletConnectContext is unavailable.');
	}

	return context;
};
